import styled from 'styled-components';

const DayPickerWrapper = styled.div`
  // Setting a height for the calendar ( 325px ) so it doesn't change heights for months with 5 and 6 weeks.
  .DayPicker-wrapper {
    height: 20.3125em;
  }
  .DayPickerInput {
    width: 100%;
    position: relative;
    z-index: 100;

    .DayPickerInput-OverlayWrapper {
      position: static;
      display: none;

      .DayPickerInput-Overlay {
        bottom: 100%;

        // Internet Explorer 11 specific css to align calendar in container.
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          .DayPicker-NavBar {
            position: absolute;
            width: 100%;
          }
          .DayPicker-Months {
            width: 100%;
          }
        }

        @media screen and (min-width: ${props =>
            props.theme.breakpoints.large}) {
          left: auto;
          right: 0;
        }
      }

      @media screen and (min-width: ${props =>
          props.theme.breakpoints.extraSmall}) {
        display: block;
      }
    }

    & + .fa-calendar {
      position: absolute;
      right: 1.5em;
      top: 2em;
      pointer-events: none;
    }
  }

  input {
    &::-ms-clear {
      height: 0;
      width: 0;
      display: none;
    }
    font-family: ${props => props.theme.font};
    color: ${props => props.theme.colors.black};
    border: 0.0625em solid
      ${props =>
        props.error ? props.theme.colors.red : props.theme.colors.black};
    height: 2em;
    width: 100%;
    padding: 0 0.3em;
    border-radius: 0;

    &:focus {
      box-shadow: ${props => props.theme.forms.input.focusOutline};
    }
  }
`;

export default DayPickerWrapper;
